import { render, staticRenderFns } from "./ChartDocumentTypes.vue?vue&type=template&id=3dae4794&scoped=true&"
import script from "./ChartDocumentTypes.vue?vue&type=script&lang=js&"
export * from "./ChartDocumentTypes.vue?vue&type=script&lang=js&"
import style0 from "./ChartDocumentTypes.vue?vue&type=style&index=0&id=3dae4794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae4794",
  null
  
)

/* custom blocks */
import block0 from "./ChartDocumentTypes.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports